import { useMedia } from "react-use";
import { useFeatureFlagToggle } from "./useFeatureFlags";
import { useAppContext } from "./useAppContext";

let lastLog: boolean | undefined = undefined;

/**
 * Currently for width >= 768px, height not considerd for a left sidebar
 * Layout is only related to screen size, not related to touch
 */
export function useShowDesktopLayout() {
	const { logger } = useAppContext();
	// breakpoint is based on visible buttons in text-top-menu: font-name, font-size, text-color, trashbin
	const isDesktopSize = useMedia("(min-width: 860px)");
	const allowDesktopLayout = useFeatureFlagToggle("useDesktopLayout");
	const result = isDesktopSize && allowDesktopLayout;

	if (lastLog !== result) {
		logger.info(
			`Layout ${lastLog === undefined ? "at startup" : "switched to"}: ${
				result ? "desktop" : "mobile"
			}`,
		);

		// Allow, is not used as state, only for logging once
		// eslint-disable-next-line react-compiler/react-compiler
		lastLog = result;
	}
	return isDesktopSize && allowDesktopLayout;
}
